import SACM0A0XX0EU0 from './SACM-0A0XX0EU0.js';
import S1CM0DXW00 from './S1CM-0DXW00.js';

export const Camera = {
	'SACM-0A0XX0EU0': SACM0A0XX0EU0,
	'S1CM-0DXW00': S1CM0DXW00,
};
